import { styled } from 'styled-components';

export const Arrow = styled.div`
    position: absolute;
    left: -80px;
    top: 10px;
    transform: rotate(-20deg) scale(0.8);
`;
